let Dialog = require("./Dialog");

class Alert extends Dialog {
  constructor(props) {
    super(props);

    this.state.input = props.input;
  }

  cancel() {
    this.hide(false);
  }

  confirm() {
    this.hide(true, this.state.input);
  }

  setInput(evt) {
    this.setState({
      input: evt.target.value
    });
  }

  render() {
    let { level, message, input, inputLimit, mode, labels } = this.props;

    return (
      <div className="mc-alert-scrim" tabIndex="0">
        <div
          className="mc-alert-dialog"
          data-level={level}
          ref="dialog"
          role="alertdialog"
          aria-describedby="mc-alert-body"
          tabIndex="-1">
          <div className="mc-alert-body">
            <p>{message}</p>
            {input !== null &&
              (inputLimit <= 64 ? (
                <input
                  type="text"
                  size="24"
                  maxLength={inputLimit}
                  value={this.state.input}
                  onChange={this.setInput.bind(this)}/>
              ) : (
                <textarea
                  rows="6"
                  cols="32"
                  maxLength={inputLimit}
                  value={this.state.input}
                  onChange={this.setInput.bind(this)}/>
              ))
            }
          </div>
          <div>
            {mode !== "alert" && (
              <button className="mc-button mc-alert-cancel" onClick={this.cancel.bind(this)}>
                {labels.cancel || tx("cancel")}
              </button>
            )}
            <button
              className="mc-button mc-alert-confirm"
              onClick={this.confirm.bind(this)}
              disabled={input !== null && this.state.input.trim() === ""}>
                {labels.confirm || tx("okay")}
            </button>
          </div>
        </div>
      </div>
    );
  }
}

Alert.defaultProps = {
  level: "info",
  mode: "alert",
  dismissable: true,
  labels: {
    // cancel: "Cancel",
    // confirm: "Okay"
  },
  input: null,
  inputLimit: 64,
  selector: "button, input"
};

module.exports = Alert;
